import Select from "react-select";
import AsyncSelect from "react-select/async";
import CreatableSelect from "react-select/creatable";
import { adminSelectBaseProps } from "./adminSelectStyles";

type FinalFormInput = {
	value: unknown;
	onChange: (v: unknown) => void;
	onBlur?: () => void;
	onFocus?: () => void;
};

export function AdminCreatableSelectAdapter({
	input,
	...rest
}: {
	input: FinalFormInput;
	[x: string]: unknown;
}) {
	return (
		<CreatableSelect
			{...adminSelectBaseProps}
			{...rest}
			value={input.value || null}
			onChange={(value) => input.onChange(value)}
		/>
	);
}

export function AdminSelectAdapter({
	input,
	...rest
}: {
	input: FinalFormInput;
	[x: string]: unknown;
}) {
	return (
		<Select
			{...adminSelectBaseProps}
			{...rest}
			value={input.value}
			onChange={input.onChange}
			onBlur={input.onBlur}
			onFocus={input.onFocus}
		/>
	);
}

export function AdminAsyncSelectAdapter({
	input,
	...rest
}: {
	input: FinalFormInput;
	[x: string]: unknown;
}) {
	return (
		<AsyncSelect
			{...adminSelectBaseProps}
			{...rest}
			value={input.value}
			onChange={input.onChange}
			onBlur={input.onBlur}
			onFocus={input.onFocus}
		/>
	);
}
